import { Link } from "react-router-dom";
import { FadeIn } from "../components/FadeIn";

const PILLARS = [
  { title: "Strength", body: "The Capra endures where others turn back. Every piece is built to outlast seasons, trends, and time itself." },
  { title: "Elevation", body: "Born of the high places. We craft for those who climb — in ambition, in taste, in life." },
  { title: "Refinement", body: "Bronze hardware cast by hand. Leather burnished until it glows. Nothing leaves the atelier unfinished." },
];

export default function Maison() {
  return (
    <div data-testid="maison-page">
      <section className="relative h-[70vh] min-h-[480px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 monogram-hero-bg" />
        <FadeIn className="relative z-10 text-center px-6">
          <p className="overline-label mb-5" style={{ letterSpacing: "0.4em" }}>The Maison</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-capra-ivory tracking-[0.12em]">
            A House of Strength<br />and Refinement
          </h1>
        </FadeIn>
      </section>

      <section className="py-24 lg:py-32 px-6 max-w-3xl mx-auto text-center">
        <FadeIn>
          <img src="/brand/goat-emblem.jpg" alt="Capra Falconeri emblem" className="mx-auto w-36 aspect-[3/4] object-cover border border-capra-bronze/40 shadow-2xl shadow-black/70 mb-12" />
          <p className="font-display text-xl md:text-2xl text-capra-ivory leading-relaxed italic">
            "Born from the symbolism of the Capra — strength, balance, elevation, and refined endurance. Capra Falconeri creates pieces designed for presence, movement, and timeless distinction."
          </p>
          <div className="hairline my-14" />
          <p className="text-sm text-capra-muted leading-loose">
            Mountain strength meets Italian-style leather luxury. The goat of the high cliffs — sure-footed, unshakable, ascendant — is pressed into every hide, cast into every clasp, and woven into every thread that carries our name. The monogram is not decoration. It is a promise: that what you wear was made slowly, deliberately, and for you alone.
          </p>
        </FadeIn>
      </section>

      <section className="py-20 monogram-veil bg-capra-surface/40">
        <div className="px-6 lg:px-10 max-w-[1400px] mx-auto grid md:grid-cols-3 gap-6">
          {PILLARS.map((p, i) => (
            <FadeIn key={p.title} delay={i * 0.1}>
              <div className="leather-panel p-10 h-full">
                <p className="font-display text-2xl text-capra-bronze mb-4">{p.title}</p>
                <p className="text-sm text-capra-muted leading-relaxed">{p.body}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <section className="py-24 lg:py-32 text-center px-6">
        <FadeIn>
          <p className="font-display italic text-lg md:text-xl text-capra-beige/90 mb-8">Dark Leather. Bronze Marks. Timeless Presence.</p>
          <Link
            to="/new-collection"
            data-testid="maison-explore-cta"
            className="inline-block px-10 py-4 bg-capra-bronze text-capra-night text-[11px] uppercase tracking-[0.25em] font-semibold hover:bg-capra-amber transition-colors"
          >
            Explore the Collection
          </Link>
        </FadeIn>
      </section>
    </div>
  );
}
